import { hooks } from "./hookactions"
export let QUTOfferingSettings = { hooks }
